import store from '@/store';
import Cookie from 'js-cookie';
import { isWeChatBrowser, isYueYeApp } from '@/utils/is';
import dsbridge from 'dsbridge';

/**
 * 需要获取token的页面，在此添加一级路由路径
 */
const luckyRoutes = [
  '/luckyDraw/', // 抽奖
  '/cars/', // 车型下订
  '/order/', // 车型下订
  '/purchaseGift/', // 推荐赢好礼
  '/runningReport/', // 行车报告
  '/expectModel/', // 行车报告
  '/feedback/', // 意见反馈
  '/maintenance/', // 预约维保
  '/rescue/', // 救援查询
  '/equity/detail', // 权益详情
  '/maintenanceRecord/list', // 维保记录
  '/liveBroadcast/detail', // 短视频详情
  '/inspectionRecord', // 检测记录
  '/myInvite', // 我的邀请（超级合伙人）
  '/user', // 个人中心
  '/replacement', // 置换页面
  '/vehiclePackages', // 流量查询页面
  '/winningRecord', // 活动订单页面
];

export function createPermissionGuard(router) {
  router.beforeEach(async(to, from, next) => {
    const authStatus = luckyRoutes.find(item => to.path.includes(item));
    if (!authStatus) {
      // 可以直接进入页面
      return next();
    }
    const { userInfo } = store.getters;
    if (userInfo.token || store.getters.isYueye) {
      return next();
    }
    const { userId: uid = '', token = '', modelId = '', mobile, yyUserId = '', isYueye = '' } = to.query;
    console.log(to.query, 'isYueye');
    if (isWeChatBrowser()) {
      if (isYueye) {
        Cookie.set('userid', to.query.uid);
        Cookie.set('usersig', token);
        Cookie.set('mobile', mobile);
        store.dispatch('setIsYueYe', true);
      }
      else {
        Cookie.remove('usersig');
        Cookie.remove('userid');
        store.dispatch('setIsYueYe', false);
        // 微信
        store.dispatch('setUserInfo', {
          uid, token, modelId,
          yyUserId,
          mobile: mobile || Cookie.get('mobile'),
        });
      }
      return next();
    }
    // 判断是悦野圈还是北京汽车app
    if (isYueYeApp()) {
      const user = dsbridge.call('getUserInfo');
      const userInfo = typeof user === 'string' ? JSON.parse(user) : user;
      store.dispatch('setIsYueYe', true);
      Cookie.set('mobile', userInfo.phone);
      // console.log(to.query);
      // const { userId, userSig } = to.query;
      // if (userId || userSig) {
      //   console.log('进入路由');
      //   Cookie.set('userid', userId);
      //   Cookie.set('usersig', userSig);
      // }
      next();
    }
    else {
      store.dispatch('setIsYueYe', false);
      let num = 1;
      let timer = setInterval(() => {
      // app异步返回用户信息
        if (!window.uid || !window.token) {
          num++;
        }
        if ((window.uid && window.token) || num === 10) {
          console.log('app异步返回uid等信息', num);
          const info = {
            uid: window.uid,
            token: window.token,
            modelId: window.modelId,
            mobile: window.mobile || Cookie.get('mobile'),
            yyUserId: Cookie.get('yyUserId'),
          };
          store.dispatch('setUserInfo', info);
          clearInterval(timer);
          timer = null;
          num = 1;
          next();
        }
      }, 500);
    }
  });
}
